"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PricingPoint_1 = require("../PricingPoint");
const SupportingCreativeFormatAttribute_1 = require("./SupportingCreativeFormatAttribute");
class SupportingCreativeFormatCreativeType {
    constructor({ id, key, name, attribute, requiredPoints, }) {
        this.toJSON = () => ({
            id: this.id,
            key: this.key,
            name: this.name,
            attribute: this.attribute.toJSON(),
            requiredPoints: this.requiredPoints,
        });
        this.id = id;
        this.key = key;
        this.name = name;
        this.attribute = attribute;
        this.requiredPoints = requiredPoints;
    }
}
SupportingCreativeFormatCreativeType.fromJSON = (json) => {
    const { id, key, name, attribute, requiredPoints } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof key !== 'string')
        throw new Error('.key must be a string');
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    switch (key) {
        case 'video':
        case 'static_image':
            // OK
            break;
        default:
            throw new Error(`A creative type key "${key}" is not valid.`);
    }
    return new SupportingCreativeFormatCreativeType({
        id,
        key,
        name,
        attribute: SupportingCreativeFormatAttribute_1.default.fromJSON(attribute),
        requiredPoints: requiredPoints && requiredPoints.map(_requiredPoint => PricingPoint_1.default.fromJSON(_requiredPoint)),
    });
};
exports.default = SupportingCreativeFormatCreativeType;
